// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"4eee0d7c","479":"9fe8719d","485":"155b1202","531":"9abde60e","915":"a1005684","949":"f3baa559"}[chunkId] + ".chunk.js";
};